import { render, staticRenderFns } from "./AlarmHandler.vue?vue&type=template&id=81497992"
import script from "./AlarmHandler.vue?vue&type=script&lang=js"
export * from "./AlarmHandler.vue?vue&type=script&lang=js"
import style0 from "./AlarmHandler.vue?vue&type=style&index=0&id=81497992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports